
































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import {
  FormatReference,
  FormatSet,
  WriteMethodTypeValue,
} from "../../../domain/format";
import { ModelEditableMixin } from "../../system/mixins";
import FormatsSelector from "./FormatsSelector.vue";
import FormatReferencesListBoxSelector from "./FormatReferencesListBoxSelector.vue";
import { DeveloperPresentableMixin } from "../../developer/mixins";
import { IFormatTreeSourceFilterable } from "./trees/sources";

@Component({
  components: {
    FormatsSelector,
    FormatReferencesListBoxSelector,
  }
})
export default class FormatSelector extends Mixins(ModelEditableMixin, DeveloperPresentableMixin) {
  static readonly Tabs: {[key: string]: any} = FormatsSelector.Tabs;
  static readonly formatTabs: any[] = FormatsSelector.formatTabs;
  static readonly formatSetTabs: any[] = FormatsSelector.formatSetTabs;
  static readonly allTabs: any[] = FormatsSelector.allTabs;

  @Prop({ default: null })
  isReady: boolean;

  @Prop()
  visibleTabs: any[];

  @Prop({ default: null })
  formatId: number;

  /**
   * formatIdはoptionsのgetterからアクセスされており、リアクティブに組み込まれているので
   * 上位のコンポーネントからformatIdを変更したとき、CustomListBoxSelector内に意図しないリアクティブの挙動を与えてしまう
   * 対策として、optionsに組み込まれていないPropを別で用意している
   */
  @Prop({ default: null })
  firstSelectedFormatWithoutSort: FormatReference;

  @Prop({ default: null })
  formatName: string;

  @Prop()
  formatTreeSourceFilter: IFormatTreeSourceFilterable;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop({ default: false })
  containsExpired: boolean;

  @Prop({ default: false })
  containsDeleted: boolean;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: null })
  defaultWriteMethodTypes: WriteMethodTypeValue[];

  data(): any {
    return {
      values: [],
      hashTableDirectoryPathForEachFormat: {},
    };
  }
  values: FormatReference[];
  hashTableDirectoryPathForEachFormat: { [key: number]: string };
  isFormatsLoadCompleted: boolean = false;

  formatsLoadCompleted(): void {
    if (this.isFormatsLoadCompleted) { return; }
    this.isFormatsLoadCompleted = true;

    // CustomListBoxSelectorのoptionsを更新したとき、
    // editingSourceと一致するものがoptionsに含まれていない場合、editingSourceがクリアされる。
    // WF依頼引用画面のフォーマット選択ダイアログの初回表示で選択がクリアされてしまうので、
    // フォーマットツリーのロードが完了してoptionsが更新された後に格納しなおしている。
    if (!this.editingSource && this.firstSelectedFormatWithoutSort) {
      this.editingSource = this.firstSelectedFormatWithoutSort;
    }
  }

  onUpdatedSelectedSelectorTab(value: any): void {
    // タブが切り替わったとき、選択をクリアする
    this.editingSource = null;
  }

  hashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.hashTableDirectoryPathForEachFormat = value;
  }

  @Emit("editingFormat")
  editingFormat(value: boolean): void {}

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Emit("formatSetSelectionChanged")
  onFormatSetSelectionChanged(value: FormatSet): void {}

  @Emit("formatSetDoubleClicked")
  onFormatSetDoubleClicked(): void {}
}
